import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Reference } from '../../../models';
import { Tag } from '../../../models/tag.model';
import { ReferenceModalComponent } from '../reference-modal/reference-modal.component';

@Component({
    selector: 'rms-text-content-tags',
    templateUrl: './text-content-tag.component.html',
    styleUrls: ['./text-content-tag.component.scss'],
    standalone: false
})
export class TextContentTagComponent implements OnInit {

  @Input() tags: Array<Tag>;
  @Input() entity: string;
  @Input() isReadOnly: boolean;
  @ViewChild(ReferenceModalComponent, { static: true }) referenceModal: ReferenceModalComponent;

  constructor() { }

  ngOnInit() {
  }

}
